var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96967 4.46967C7.7034 4.73594 7.6792 5.1526 7.89705 5.44621L7.96967 5.53033L14.439 12L7.96967 18.4697C7.7034 18.7359 7.6792 19.1526 7.89705 19.4462L7.96967 19.5303C8.23594 19.7966 8.6526 19.8208 8.94621 19.6029L9.03033 19.5303L16.0303 12.5303C16.2966 12.2641 16.3208 11.8474 16.1029 11.5538L16.0303 11.4697L9.03033 4.46967C8.73744 4.17678 8.26256 4.17678 7.96967 4.46967Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontArrow);
export default __webpack_public_path__ + "static/media/FrontArrow.c6f81fae46a59aeaee34449dc362db6b.svg";
export { ForwardRef as ReactComponent };